module.exports = __webpack_public_path__ + "static/img/google.7c1a525b.png";